import { render, staticRenderFns } from "./BlockQuoteImage.vue?vue&type=template&id=88622fb2&"
import script from "./BlockQuoteImage.vue?vue&type=script&lang=js&"
export * from "./BlockQuoteImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports